var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpreadsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "url(#pattern0_638_889)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_638_889",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_638_889",
    transform: "matrix(0.0104167 0 0 0.0108696 0 -0.0217391)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_638_889",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACD0lEQVR4nO2dQU4dQQxEa0HOEnLVAOE0wD0SLhJglb8oNNKsgr4+kjVdbfo9yUtLLpfdPatpCQAAAAAAAAAA4PP8kPRL0rOkN0n+4vEm6Y+kO0nXyUH5Jule0mmCpjgUp92Iq0TznyZogCeJx9Em3E8g2pPFtgnDzvyVjx2fia0n30cYwPTrrAm3Iwx4nmDaPGlsX0eH8zqBUE8aLyMMuFTEV8dp/fECwsT1xwsIE9cfLyBMXH+8gDBx/fECwsT1xwsIE9cfLyBMXP+lAlaPw0kL9OSBAcKA+BSaDcg3whxB+WY4ENwBwoD4FHrlDSD/YDBAbIAbb2CZtAA3zy+TFuDm+WXSAtw8v0xagJvnl0kLcPP8MpcKWD0OJy3QkwcGCAPiU2g2IN8IcwTlm+FAcAcIA+JT6JU3gPyDwQCxAW68gWXSAtw8v0xagJvnl0kLcPP8MmkBbp5fJi3AzfPLXCpg9TictEBPHhggDIhPodmAfCPMEZRvhgPBHSAMiE+hV94A8g8GA8QGuPEGlkkLcPP8MmkBbp5fJi3AzfPLpAW4eX6ZtAA3zy/z8okiVo2/Iwzg18U6a8DvEQbcTTBpnjR+jjBge7aD39frQ/P/jfp9/QZboA8G3Ggg23MdDxOsvCeJh8Q7Mlf7Jqx8HJ32yR/e/P/vhNv98YIV3hZ43bXejDzzAQAAAAAAAABA7XkHKHg4ybIF13EAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpreadsheet);
export default __webpack_public_path__ + "static/media/spreadsheet.158ed406de4f693196e7041abe15a94e.svg";
export { ForwardRef as ReactComponent };